import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { ChangeDetectorRef, Component, DestroyRef, ElementRef, HostListener, inject, OnDestroy, OnInit, QueryList, signal, TemplateRef, ViewChild, ViewChildren , WritableSignal} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ESLeadSheetModel, SPIN_APPEND, SPIN_STYLES, SpinInputModel, UserDetailModel, UserModel, WorksheetProceduresDBModel } from 'countable@model';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, distinctUntilChanged, finalize, forkJoin, Observable, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { DragAndDropService } from 'src/app/components/shared/drag-and-drop.service';
import { SharedService } from 'src/app/components/shared/shared.service';
import { DraggedFileModel } from 'src/app/model/file/drag/dragged-file.model';
import { ResponseItemModel } from 'src/app/model/file/drag/responce/response-item.model';
import { SourceElementModel } from 'src/app/model/file/drag/source-element.model';
import { LSNature, LSType, MasterTemplateData, WorkbookTableData } from 'src/app/model/template/worksheet.model';
import { ApiService } from 'src/app/services/api.service';
import { ModuleInfo } from 'src/app/services/app-config';
import { EncodingService } from 'src/app/services/encoding.service';
import { WorksheetService } from 'src/app/services/worksheet.service';
import { AuthService } from '../../../../services/auth.service';
import { EngApiService } from '../../../../services/eng-api.service';
import { EngService } from '../../../../services/eng.service';
import { AclModel } from 'src/app/model/acl.model';
import { AclService } from 'src/app/services/acl.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CountableTimeZonePipe } from 'countable@helpers';

@Component({
  selector: 'app-worksheet-procedures',
  templateUrl: './worksheet-procedures.component.html',
  styleUrls: ['./worksheet-procedures.component.scss'],
  standalone: false
})
export class WorksheetProceduresComponent implements OnInit, OnDestroy {

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  @ViewChild('deleteSectionDailog') deleteSectionDailog: TemplateRef<any>;
  @ViewChild('tinymceSectionDailog') tinymceSectionDailog: TemplateRef<any>;
  @ViewChildren('user', {read: ElementRef}) renderedUsers: QueryList<ElementRef>;
  @ViewChild('newDailogFolder') newDailogFolder: TemplateRef<any>;
  @ViewChild('selectComponent') selectComponent: TemplateRef<any>;
  @ViewChild('alertUnsavedChangesDialog') alertUnsavedChangesDialog: TemplateRef<any>;
  @ViewChild('freeEngagementDialog') freeEngagementDialog: TemplateRef<any>;
  @ViewChild('textEditor') textEditor: TemplateRef<any>;
  @ViewChild('duplicateLetterTemplateDialog') duplicateLetterTemplateDialog: TemplateRef<any>;
  @ViewChild('freeBlankFirmTemplateFileFolderDialog') freeBlankFirmTemplateFileFolderDialog: TemplateRef<any>;
  @ViewChild('editDailogopen') editDailogopen: TemplateRef<any>;
  @ViewChild('defaultSaveConfirmDialogBox') defaultSaveDialog: TemplateRef<any>;
  @ViewChild('cancelTemplateDialog') cancelTemplateDialog: TemplateRef<any>;
  @ViewChild('deleteTemplateDialog') deleteTemplateDialog: TemplateRef<any>;
  @ViewChild('deleteHiddenTemplateDialog') deleteHiddenTemplateDialog: TemplateRef<any>;
  @ViewChild('addRefrence') WPRefTemplateDialog: TemplateRef<any>;
  @ViewChild('reopenWorksheetDialog') reopenWorksheetDialog: TemplateRef<any>;
  @ViewChild('referenceMenu') referenceMenu: MatMenuTrigger;

  displayedColumns = ['select', 'nature', 'type', 'description', 'comments', 'wpref', 'status', 'actions'];
  dataSource = new MatTableDataSource<WorkbookTableData>();
  hiddenDataSource = new MatTableDataSource<WorkbookTableData>();
  selection = new SelectionModel<WorkbookTableData>(true, []);
  hiddenSelection = new SelectionModel<WorkbookTableData>(true, []);

  panelOpenState: boolean = true;
  userData: UserDetailModel;
  user: UserModel;
  public navigateSub: Subscription;
  public currentTemplateData: any = [];
  public templateType: string;
  masterTemplateData: any = MasterTemplateData;
  showTemplateView: boolean = false;
  public isViewChange: boolean = false;
  public enableCancelSave: boolean = false;
  public isDescriptionEmpty: boolean = true;
  public isRestore: boolean = true;
  public selectedTab: Subscription;
  isMasterTab = false;
  leadSheetName: string = '';
  procedureFilePath: any;
  procedureFileName: any;
  natureDate = LSNature;
  typesData = LSType;
  filePath: any;
  public masterTemplate: any = {};
  public TemplateData: any = [];
  leadsheetBalance: number = 0;
  public CurrentTemplateData: any = [];
  public showErrorMessage: any = [];
  engagementData: any;
  concludeWorksheet: any;
  acctYear: any;
  engagementID: any;
  conclusion: string = 'Based on my review, nothing has come to my attention that causes me to believe that cash is not presented fairly, in all material respects, in accordance with the applicable financial reporting framework.';
  dropFileDetails: any = [];
  referenceDocRightSideList: any = [];
  referenceDocLeftSideList: any = [];
  selectedLeftDocs: any[];
  selectedRightDocs: any[];
  referenceDocList: any[];
  isLeftSideSelectAll = false;
  docData: any = [];
  isClicked = false;
  label: any;
  isShow: boolean;
  isReopen: boolean;
  isVisible: boolean;
  isView: boolean;
  isRightSideSelectAll = false;
  selectedSection = '1';
  materialityValue: number;
  isAdditionalProcedure: number; // 0 = Hide A_P 1 = Show A_P
  isDisable: boolean;
  hiddenRow: any;
  mainRow: any;
  renameProcedureDocSubscription: Subscription;
  isFilesExists: any;
  isRefChanged = false;
  public materialityFilePath: string = '';
  public fsaLeadSheet$: BehaviorSubject<ESLeadSheetModel[]> = new BehaviorSubject<ESLeadSheetModel[]>([]);
  public sourceFilePath: any;
  workSheetsDocsDelete: any;
  leftdocTypeId;
  rightdocindex;
  isAddRowBtnEnabled = signal(false);
  ProcRefSubscription: Subscription;
  private subcriptions: Subscription = new Subscription();
  private leadSheetData: any;
  private routeUrl: string;
  private readonly unSubscribe$: Subject<void> = new Subject<void>();
  private readonly authSubject: Subscription = null;
  acl: AclModel;
  private destroyRef = inject(DestroyRef);
  public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(SPIN_APPEND.HOST, SPIN_STYLES.BLUR_WITH_SPIN));
  private spinCount: number = 0;

  constructor(private apiService: ApiService, private sharedService: SharedService,private countableTimeZonePipe : CountableTimeZonePipe,
              private worksheetService: WorksheetService, private engService: EngService, private toster: ToastrService,
              private dialog: MatDialog, private dragAndDropService: DragAndDropService,
              private authService: AuthService, private cdChanges: ChangeDetectorRef, private router: Router,
              private encodingService: EncodingService, private engApiService: EngApiService, private aclService: AclService) {
    this.routeUrl = this.router.url;
    this.authSubject = this.authService.subject.subscribe(isLogin => {
      if (isLogin) {
        this.userData = this.authService.getUserDetail();
        this.user = this.authService.getUser();
      }
    });
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(ev: StorageEvent) {
    if (this.routeUrl.includes('/view-procedures')) {
      const REFRESH_KEY = this.getWorksheetKey('refresh');
      const isRefreshProcedure = localStorage.getItem(REFRESH_KEY);
      (isRefreshProcedure && isRefreshProcedure === 'true') && this.setWindowProceduresView();
    }
  }

  ngOnInit() {
    this.engagementData = JSON.parse((localStorage.getItem('selectedEngagementObj')));
    this.sharedService.cancelUnsavedChanges.subscribe(response => {
      if (response) {
        this.sharedService.isEngScopeProcedureModified = !response;
      }
    });
    if (this.engagementData) {
      this.acctYear = parseInt(this.countableTimeZonePipe.transform(this.engagementData.yearEnd, 'yyyy'));
      this.engagementID = this.engagementData.engagementsid;
    }
    this.selectedTab = this.sharedService.selectedTab$.subscribe(response => {
      this.isMasterTab = (response === 1);
      this.showTemplateView = false;
    });
    this.renameProcedureDocSubscription = this.worksheetService.updateRenameDocument.subscribe(res => {
      if (res) {
        res = JSON.parse(res.inputParameters).renamefiles[0];
        for (let ref of this.masterTemplateData.tableData) {
          if (ref.wpRef.length != 0) {
            for (let i = 0; i < ref.wpRef.length; i++) {
              if (ref.wpRef[i].engleftsidedocid == res.engleftsidedocid) {
                ref.wpRef[i].filename = res.userdocname;
                ref.wpRef[i].userdocname = res.userdocname;
              }
            }
          }
        }
      }
    });
    this.subcriptions.add(
      this.sharedService.worksheetProcedures$.pipe(
        distinctUntilChanged()
      ).subscribe({
        next: response => {
          if (response) {
            this.resetValues();
            const matEsFolders = this.engService.matEsFolders$.getValue();
            this.materialityFilePath = matEsFolders.has('Materiality') ? matEsFolders.get('Materiality').JsonFilePath : '';
            this.leadSheetData = response;
            localStorage.setItem('procedureWorksheet', JSON.stringify(this.leadSheetData));
            localStorage.setItem('materialityFilePath', this.materialityFilePath);
            this.procedureFilePath = this.leadSheetData.JsonFilePath;
            this.procedureFileName = this.leadSheetData.JsonFileName;
            this.isAdditionalProcedure = this.leadSheetData.additional_procedure;
            this.getFSA();
          } else if (!response) {
            this.routeUrl.includes('WorkSheet/Procedure') && this.setPorcedureView();
            this.routeUrl.includes('view-procedures') && this.setWindowProceduresView();
          }
        }
      })
    );

    this.subcriptions.add(
      this.sharedService.updateReOrderAndReNumber$.pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(response => {
        if (response) {
          this.getLeftRightDocList();
        }
      })
    );

    this.ProcRefSubscription = this.worksheetService.ProcedureRef.subscribe(res => {
      if (res) {
        this.addDraggedFileToRef(res, localStorage.getItem('indexForDragDrop'));
        localStorage.removeItem('dropToProcedure');
      }
    });

    this.sharedService.leftSideDocMoved.subscribe(response => {
      if (this.router.url === '/dashboard/ntrdashboard/WorkSheet/Procedure') {
        this.getLeftRightDocList();
      }
    });

    this.workSheetsDocsDelete = this.worksheetService.delWorkSheetDoc.subscribe(res => {
      if (res) {
        if (this.masterTemplateData && this.masterTemplateData.tableData && this.masterTemplateData.tableData.length) {
          for (let i = 0; i < this.masterTemplateData.tableData.length; i++) {
            let ref = this.masterTemplateData.tableData[i].wpRef;
            if (ref && ref.length) {
              let updatedRef = ref.filter(item => item.engleftsidedocid != res.engleftsidedocid);
              this.masterTemplateData.tableData[i].wpRef = JSON.parse(JSON.stringify(updatedRef));
              this.TemplateData.tableData[i].wpRef = JSON.parse(JSON.stringify(updatedRef));
            }
          }
          this.checkForWpRefDocChanges();
          this.updateReferance('');
        }
      }
    });
    this.aclService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(acl => {
      this.acl = acl;
    });
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return this.sharedService.isEngScopeProcedureModified ? false : true;
  }

  getLeftRightDocList() {
    this.referenceDocLeftSideList = [];
    this.referenceDocRightSideList = [];
    this.updateSpinnerConfig(true);
    forkJoin({
      leftResponse: this.engApiService.getProcedureLeftSectionDocs(this.engagementID),
      rightResponse: this.engApiService.getProRightSectionDocs(this.engagementID)
    }).pipe(finalize(() => this.updateSpinnerConfig(false)))
      .subscribe(({leftResponse, rightResponse}) => {

        //Left side Docs
        const responseLeft = JSON.parse(leftResponse);
        const docsArray = responseLeft.docs ? [...responseLeft.docs] : [];
        const arrList = docsArray && docsArray.length > 0 ? docsArray.filter((doc: any) => doc && doc.engleftsidedocid && doc.engteamclientdocid) : [];
        const filterdList = arrList && arrList.length > 0 ? arrList : [];

        //to remove duplicate files from response (same obj with diffrent sectionpath from db)
        this.referenceDocLeftSideList = _.uniqBy(filterdList, 'engleftsidedocid');

        //Right side Docs
        const responseRight = JSON.parse(rightResponse);
        this.referenceDocRightSideList = responseRight.docs ? [...responseRight.docs] : [];

        if (!this.enableCancelSave) {
          if (this.masterTemplateData && this.masterTemplateData.tableData && this.masterTemplateData.tableData.length) {
            this.checkForWpRefDocChanges();
          }
          if (this.isRefChanged) {
            //Save the JSON again with updated Doc reference
            this.updateReferance('');
          }
        }
      });
  }

  setPorcedureView() {
    this.getLeftRightDocList();
    if (!this.leadSheetData) {
      const data = localStorage.getItem('procedureWorksheet');
      this.materialityFilePath = localStorage.getItem('materialityFilePath');
      this.leadSheetData = JSON.parse(data);
    }
    // this.leadSheetName = this.leadSheetData.leadsheetname;
    this.procedureFilePath = this.leadSheetData.JsonFilePath;
    this.procedureFileName = this.leadSheetData.JsonFileName;
    this.isAdditionalProcedure = this.leadSheetData.additional_procedure;
    this.getFSA();
  }

  setWindowProceduresView() {
    const STORAGE_KEY = this.getWorksheetKey('data');
    const procedures = localStorage.getItem(STORAGE_KEY);
    this.leadSheetData = JSON.parse(procedures);
    this.materialityFilePath = localStorage.getItem('materialityFilePath');
    this.procedureFilePath = this.leadSheetData.filepath;
    this.procedureFileName = this.leadSheetData.JsonFileName;
    this.isAdditionalProcedure = this.leadSheetData.additional_procedure;
    this.getFSA();
  }

  getWorksheetKey(typeOfKey: 'data' | 'refresh') {
    const routerData = this.router.url.split('/');
    const leadSheetId = routerData.pop();
    const engId = routerData[routerData.length - 1];
    return typeOfKey === 'data' ? 'windowWorksheetProcedure-' + engId + '-' + leadSheetId :
      'isRefreshProceduresWindow-' + engId + '-' + leadSheetId;
  }

  resetValues() {
    this.showTemplateView = false;
    this.leadSheetName = '';
    this.masterTemplateData = [];
    this.TemplateData = [];
    this.leadsheetBalance = 0;
    this.materialityValue = 0;
    this.leadSheetData = null;
    this.procedureFilePath = '';
    localStorage.removeItem('procedureWorksheet');
    localStorage.setItem('materialityFilePath', this.materialityFilePath);
  }

  setUpdatedLsBalance() {
    const response = this.fsaLeadSheet$.getValue();
    console.log('setUpdatedLsBalance: ', response);
    if ((response && response.length > 0) && this.leadSheetData) {
      const leadSheetObj = response.find((ls: ESLeadSheetModel) => ls.submoduleid === this.leadSheetData.submoduleid);
      const finalTotal = (leadSheetObj && leadSheetObj.finaltotal) ? leadSheetObj.finaltotal : '0';
      this.TemplateData['LSAccountBal'] = finalTotal;
      this.leadsheetBalance = this.getNumber(finalTotal);
    }
  }

  getFSA() {
    let inputData = {'acctyear': this.acctYear, 'engagementsid': this.engagementID};
    let inputString = JSON.stringify(inputData);
    this.updateSpinnerConfig(true);
    this.engApiService.getLeadSheetAmount(inputString).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        const parsedResponse = res?.data ? JSON.parse(res.data) : [];
        if (parsedResponse && parsedResponse.length > 0) {
          this.fsaLeadSheet$.next(parsedResponse);
          // this.setUpdatedLsBalance();
        } else {
          this.fsaLeadSheet$.next([]);
        }
      }, error: error => {
        this.toster.error(error.error);
      }
    }).add(() => {
      this.getMasterTemplate();
    });
  }

  getMasterTemplate() {
    const MasterTemplate = {
      'module': 'Inside ENG Worksheets',
      'firmId': this.userData.firmUserAcctId,
      'status': 0,
      'folderName': null,
      'extension': 'comp',
      'appSyncId': this.userData.useracctid,
      'signatureKey': this.procedureFilePath
    };
    this.updateSpinnerConfig(true);
    this.apiService.getJsonData(MasterTemplate).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      if (response) {
        this.concludeWorksheet = false;
        const result = JSON.parse(response);
        if (result && result['tableData'] && result['tableData'].length > 0) {
          const isKeyDisclouser = result.hasOwnProperty('additional_procedure') ? (result.additional_procedure === 1) : (this.isAdditionalProcedure === 1);
          result.tableData.forEach(item => {
            // const flag = this.isAdditionalProcedure==1 ? true : false
            if (isKeyDisclouser) {
              if ((item.comments.trim() != '') || (item.wpRef && item.wpRef != '')) {
                item.isCommentAvailable = true;
              } else {
                item.isCommentAvailable = false;
                this.concludeWorksheet = true;
              }
            } else {
              if (item.nature != 'Additional Procedures') {
                if ((item.comments.trim() != '') || (item.wpRef && item.wpRef != '')) {
                  item.isCommentAvailable = true;
                } else {
                  item.isCommentAvailable = false;
                  this.concludeWorksheet = true;
                }
              }
            }
            item['isEmptyRow'] = this.isEmptyRow(item);
          });
        }
        this.masterTemplateData = result;
        if (this.masterTemplateData && this.masterTemplateData.tableData && this.masterTemplateData.tableData.length) {
          this.checkForWpRefDocChanges();
        }
        this.showTemplateView = true;
        this.hiddenRow = this.masterTemplateData.tableData.filter(data => data.isHide == true);
        this.mainRow = this.masterTemplateData.tableData.filter(data => data.isHide == false);
        this.mainRow.forEach(data => {
          data['isDescEdited'] = false;
        });

        this.selection.clear();
        this.hiddenSelection.clear();
        this.isViewChange = false;
        this.enableCancelSave = false;
        this.sharedService.isEngScopeProcedureModified = false;
        if (result instanceof Array) {
          this.TemplateData = JSON.parse(JSON.stringify(result[0]));
        } else {
          this.TemplateData = JSON.parse(JSON.stringify(result));
        }
        this.setLSBalance(this.TemplateData);
        if (this.TemplateData.isConcluded === true) {
          this.isShow = true;
          this.isClicked = true;
          this.isVisible = true;
          this.isView = true;
          this.isAdditionalProcedure = (this.TemplateData.concluderUser && this.TemplateData.concluderUser.additionalProcedures === 'Hide') ? 0 : 1;
          this.updateProcedureData(this.mainRow, this.hiddenRow);
        } else {
          this.isAdditionalProcedure = this.leadSheetData.additional_procedure;
          this.updateProcedureData(this.mainRow, this.hiddenRow);
        }
        if (this.TemplateData.isConcluded == false) {
          result.tableData.forEach(item => {
            if ((item.comments && item.comments.trim() != '') || (item.wpRef && item.wpRef != '')) {
              item.isCommentAvailable = true;
            } else {
              item.isCommentAvailable = false;
            }
          });
          if (this.hiddenRow && this.hiddenRow.length !== 0) {
            this.concludeWorksheet = true;
          }
          this.isClicked = false;
          this.isVisible = false;
          this.isShow = false;
          this.isView = false;
        }
        if (this.hiddenRow && this.hiddenRow.length !== 0) {
          this.concludeWorksheet = true;
          this.isVisible = false;
          this.isShow = false;
          this.isView = false;
          this.isClicked = false;
          this.isReopen = false;
        }
        this.TemplateData['conclusion'] = this.TemplateData['conclusion'] ? this.TemplateData['conclusion'] : this.conclusion;
        if (this.TemplateData.hasOwnProperty('additional_procedure')) {
          this.isAdditionalProcedure = this.TemplateData.additional_procedure;
        }

        if (this.isRefChanged) {
          //Save the JSON again again with updated Doc reference
          this.updateReferance('');
        }
      } else {
        console.log('Not getting any JSON data');
      }
      if (this.routeUrl.includes('view-procedures')) {
        this.isView = true;
      }
    }).add(() => {
      if (this.routeUrl.includes('/view-procedures')) {
        const REFRESH_KEY = this.getWorksheetKey('refresh');
        localStorage.setItem(REFRESH_KEY, 'false');
      }
    });
  }

  isEmptyRow(row: any) {
    if ((row.nature === 'Select' || !row.nature) && (row.type === 'Select' || !row.nature) && !row.description && !row.comments && !row.wpRef && !row.status) {
      return true;
    }
    return false;
  }

  setLSBalance(proceduresData: any) {
    this.leadSheetName = proceduresData['LSName'] ? proceduresData['LSName'] : this.leadSheetData.templatename;
    const lsBalance = proceduresData['LSAccountBal'] ? proceduresData['LSAccountBal'] : 'Automated';
    const matValue = proceduresData['materiality'] ? proceduresData['materiality'] : 'Automated';
    const isConcluded = proceduresData && proceduresData['isConcluded'] ? true : false;
    if ((lsBalance && lsBalance === 'Automated') || !isConcluded) {
      this.setUpdatedLsBalance();
    } else {
      this.TemplateData['LSAccountBal'] = lsBalance;
      this.leadsheetBalance = this.getNumber(lsBalance);
    }
    if ((matValue === 'Automated') || !isConcluded) {
      this.getMaterialityTemplate();
    } else if (isConcluded) {
      this.materialityValue = this.getNumber(this.TemplateData['materiality']);
    }
  }

  getNumber(val: string) {
    val = val.replace(/,/g, ''); // Remove all commas
    if (val.includes('(')) {
        val = val.replace(/\(|\)/g, ''); // Remove all parentheses
        return -Number(val);
    }
    return Number(val);
  }

  getMaterialityTemplate() {
    const MasterTemplate = {
      'module': 'Inside ENG Worksheets',
      'firmId': this.userData ? this.userData.firmUserAcctId : null,
      'clientId': this.userData.firmUserAcctId,
      'status': 0,
      'folderName': this.currentTemplateData.JsonFileName,
      'extension': 'comp',
      'appSyncId': this.userData.useracctid,
      'signatureKey': this.materialityFilePath
    };
    this.updateSpinnerConfig(true);
    this.apiService.getJsonData(MasterTemplate).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(response => {
      const result = JSON.parse(response);
      if (result.Template == 'Materiality') {
        const materialityCy = result.Entity_table[0].table.find((obj: any) => obj.colname === 'cy_materiality').value;
        this.materialityValue = materialityCy === '' ? 0 : materialityCy.toFixed(2);
        //chk for conclude
        let isConcluded = false;
        if (this.TemplateData) {
          isConcluded = this.TemplateData['isConcluded'] ? true : false;
        }
        if (!isConcluded) {
          this.TemplateData['materiality'] = this.materialityValue;
        }
      }
    });
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if (this.selection.selected.length !== 0) {
      this.isViewChange = true;
    } else {
      this.isViewChange = false;
    }
    this.sharedService.isEngScopeProcedureModified = this.enableCancelSave || this.isViewChange;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: WorkbookTableData): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.nature + 1}`;
  }

  onCheckboxChange(event) {
    const isChecked = event.checked;
    this.isAdditionalProcedure = event.checked == true ? 1 : 0;
    this.TemplateData.additional_procedure = this.isAdditionalProcedure;
    this.masterTemplateData.additional_procedure = this.isAdditionalProcedure;
    this.updateProcedureData(this.mainRow, this.hiddenRow);
    this.updateReferance(null);
  }

  hideSaveCancel() {
    this.cdChanges.detectChanges();
    setTimeout(() => { }, 100);
  }

  updateProcedureData(mainRow, hiddenRow, isFromAddRow?) {
    const isKeyDisclouser = this.TemplateData.hasOwnProperty('additional_procedure') ? (this.TemplateData.additional_procedure === 1) : (this.isAdditionalProcedure === 1);

    if (!isKeyDisclouser) {
      mainRow = mainRow.filter(data => data.nature != 'Additional Procedures');
      hiddenRow = hiddenRow.filter(data => data.nature != 'Additional Procedures');
    }
    mainRow.forEach(item => {
      if (item.wpRef && item.wpRef.length) {
        item.wpRef.forEach(file => {
          if (!file.extension) {
            file.extension = file.filename.substring(file.filename.lastIndexOf('.') + 1);
          }
        });
      }
      // const flag = this.isAdditionalProcedure === 1 ? true : false
      if (isKeyDisclouser) {
        if ((item.comments != '') || (item.wpRef != '')) {
        } else {
          this.concludeWorksheet = true;
        }
      } else {
        if (item.nature != 'Additional Procedures') {
          if ((item.comments != '') || (item.wpRef != '')) {
            this.concludeWorksheet = false;
          } else {
            this.concludeWorksheet = true;
          }
        }
      }
    });
    this.dataSource = new MatTableDataSource(mainRow);
    this.hiddenDataSource = new MatTableDataSource(hiddenRow);
    this.worksheetProcData();
    if (isFromAddRow) {
      setTimeout(() => {
        document.getElementsByClassName('procTableClss')[document.getElementsByClassName('procTableClss').length - 1].scrollIntoView({block: 'center'});
      }, 100);
    }
  }


  //Check for reference name change
  checkForWpRefDocChanges() {
    this.isRefChanged = false;
    if (this.referenceDocLeftSideList.length || this.referenceDocRightSideList.length) {
      this.masterTemplateData.tableData.forEach((item, mainIndex) => {
        if (item.wpRef && item.wpRef.length) {
          item.wpRef.forEach((doc, refIndex) => {
            let leftIndex = this.referenceDocLeftSideList.findIndex(x => x.engteamclientdocid === doc.engteamclientdocid);
            let rightIndex = this.referenceDocRightSideList.findIndex(x => x.engteamclientdocid === doc.engteamclientdocid);
            if (leftIndex > -1 && doc.REF !== this.referenceDocLeftSideList[leftIndex].REF) {
              this.masterTemplateData.tableData[mainIndex].wpRef[refIndex] = JSON.parse(JSON.stringify(this.referenceDocLeftSideList[leftIndex]));
              this.TemplateData = JSON.parse(JSON.stringify(this.masterTemplateData));
              this.isRefChanged = true;
            }
            if (rightIndex > -1 && doc.REF !== this.referenceDocRightSideList[rightIndex].REF) {
              this.masterTemplateData.tableData[mainIndex].wpRef[refIndex] = JSON.parse(JSON.stringify(this.referenceDocRightSideList[rightIndex]));
              this.TemplateData = JSON.parse(JSON.stringify(this.masterTemplateData));
              this.isRefChanged = true;
            }
          });
        }
      });
    }
  }

  //for hidden row table data

  isAllHiddenRowsSelected() {

    const numSelected = this.hiddenSelection.selected.length;
    const numRows = this.hiddenDataSource.data.length;
    if (this.hiddenSelection.selected.length !== 0) {
      this.isRestore = false;
    } else {
      this.isRestore = true;
    }
    return numSelected === numRows;
  }

  toggleAllHiddenRows() {
    if (this.isAllHiddenRowsSelected()) {
      this.hiddenSelection.clear();
      return;
    }
    this.hiddenSelection.select(...this.hiddenDataSource.data);
  }


  hiddenCheckboxLabel(row?: WorkbookTableData): string {
    if (!row) {
      return `${this.isAllHiddenRowsSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.hiddenSelection.isSelected(row) ? 'deselect' : 'select'} row ${row.nature + 1}`;
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.displayedColumns, event.previousIndex, event.currentIndex);
  }

  togglePanel() {
    this.panelOpenState = !this.panelOpenState;
  }

  ValidateJsonSections() {
    this.masterTemplate.parent.forEach(t => {
      t.childern.forEach(s => {
        if (s.section.length === 0) {
          this.showErrorMessage = true;
        } else {
          this.showErrorMessage = false;
        }
      });
    });
    return this.showErrorMessage;
  }

  removeSelected(originalArray: any[], selectedArray: any[]) {
    const temp = [];
    for (const obj of originalArray) {
      const matchingObj = selectedArray.find(updatedObj => obj.typeId === updatedObj.typeId);
      if (!matchingObj) {
        temp.push(obj);
      }
    }
    return temp;
  }

  isEqual(obj1: any, obj2: any): boolean {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
    return true;
  }

  changeVal(value, property, row) {
    const ind = this.TemplateData.tableData.findIndex(ele => ele.typeId === row.typeId);
    this.TemplateData.tableData[ind][property] = value;
    this.onEditTemplate();
  }

  // update review json template on S3 after changes happening
  updateReviewTemplateJSON(message: string) {
    if (this.ValidateJsonSections) {
      // this.TemplateData = JSON.parse(JSON.stringify(this.masterTemplateData));
      const formData: FormData = this.worksheetService.getProceduresDataS3InsideEng(this.procedureFileName, this.TemplateData);
      this.updateSpinnerConfig(true);
      this.apiService.saveAndGetFileNamePath(formData).pipe(
        tap(response => {
          this.setAsWIP();
        }),
        finalize(() => this.updateSpinnerConfig(false))
      ).subscribe(response => {
        this.toster.success(message);
      }, error => {
        this.toster.error(error.error);
      }).add(() => {
        this.getMasterTemplate();
        this.setRefreshProceduresWindow();
      });
    }
  }

  hideProcedures() {
    this.modifyTemplateData(this.TemplateData.tableData, this.selection.selected, true);
    this.updateReviewTemplateJSON('Rows hidden successfully');
  }

  restoreProcedures() {
    this.modifyTemplateData(this.TemplateData.tableData, this.hiddenSelection.selected, false);
    this.updateReviewTemplateJSON('Rows restored successfully');
  }

  modifyTemplateData(originalArray: any[], selectedArray: any[], value: boolean) {
    for (const obj of originalArray) {
      const matchingObj = selectedArray.find(updatedObj => obj.typeId === updatedObj.typeId);
      if (matchingObj) {
        obj.isHide = value;
      }
    }
    this.TemplateData.tableData = originalArray;
  }

  addProcedures() {
    const procedure = new WorkbookTableData();
    const sortIds: number[] = this.TemplateData.tableData.map((row: any) => row.sortOrder);
    const typeIds: number[] = this.TemplateData.tableData.map((row: any) => row.sortOrder);
    procedure.nature = '';
    procedure.type = '';
    procedure.description = '';
    procedure.comments = '';
    procedure.wpRef = '';
    procedure.status = '';
    procedure.typeId = this.getMaxNumber(typeIds);
    procedure.isHide = false;
    procedure.sortOrder = this.getMaxNumber(sortIds);
    procedure.auther = this.userData.fullName;
    procedure.created = new Date().toUTCString();

    this.selection.selected.push(procedure);
    if (this.selection.selected.length !== 0) {
      this.isViewChange = true;
      this.concludeWorksheet = true;
      this.isShow = false;
    } else {
      this.isViewChange = false;
    }
    this.isDescriptionEmpty = false;
    this.sharedService.isEngScopeProcedureModified = this.enableCancelSave || this.isViewChange;
    this.TemplateData.tableData.push(procedure);
    this.masterTemplateData.tableData.push(procedure);
    this.hiddenRow = this.TemplateData.tableData.filter((data: any) => data.isHide === true);
    this.mainRow = this.TemplateData.tableData.filter((data: any) => data.isHide === false);
    this.updateProcedureData(this.mainRow, this.hiddenRow, true);
  }

  deletProcedures() {
    const dialogRef = this.dialog.open(this.deleteTemplateDialog, {
      disableClose: true,
      id: 'delete_template'
    });
    dialogRef.afterOpened().subscribe(opened => { });
    dialogRef.afterClosed().subscribe(closed => {
      if (closed) {
        const procedures = this.removeSelected(this.TemplateData.tableData, this.selection.selected);
        this.TemplateData.tableData = procedures;
        this.updateReviewTemplateJSON('Rows deleted successfully');
      } else {

      }
    });
  }

  deletHiddenProcedures() {
    const dialogRef = this.dialog.open(this.deleteHiddenTemplateDialog, {
      disableClose: true,
      id: 'delete_template'
    });
    dialogRef.afterOpened().subscribe(opened => { });
    dialogRef.afterClosed().subscribe(closed => {
      if (closed) {
        const procedures = this.removeSelected(this.TemplateData.tableData, this.hiddenSelection.selected);
        this.TemplateData.tableData = procedures;
        this.updateReviewTemplateJSON('Rows deleted successfully');
      } else {

      }
    });
  }

  cancelSave() {
    const dialogRef = this.dialog.open(this.cancelTemplateDialog, {
      disableClose: true,
      id: 'cancel_template'
    });
    dialogRef.afterOpened().subscribe(opened => { });
    dialogRef.afterClosed().subscribe(closed => {
      if (closed) {
        this.getMasterTemplate();
      } else {
        console.log('No');
      }
    });
  }

  ngOnDestroy(): void {
    this.routeUrl.includes('/view-procedures') && localStorage.setItem('isRefreshProceduresWindow', 'false');
    if (this.navigateSub) {
      this.navigateSub.unsubscribe();
    }
    this.subcriptions && this.subcriptions.unsubscribe();
    this.authSubject && this.authSubject.unsubscribe();
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    if (this.selectedTab) {
      this.selectedTab.unsubscribe();
    }
  }

  concludeWorksheets() {
    if (this.ValidateJsonSections) {
      if (this.concludeWorksheet === false) {
        this.TemplateData.isConcluded = true;
        this.TemplateData.concluderUser = {
          'userName': this.userData.fullName,
          'timing': new Date().toUTCString(),
          'additionalProcedures': this.isAdditionalProcedure === 0 ? 'Hide' : 'Show'
        };
        this.TemplateData['materiality'] = this.materialityValue;
        const formData: FormData = this.worksheetService.getProceduresDataS3InsideEng(this.procedureFileName, this.TemplateData);
        this.updateSpinnerConfig(true);
        this.apiService.saveAndGetFileNamePath(formData).pipe(
          tap(response => {
            this.setAsWIP();
          }),
          finalize(() => this.updateSpinnerConfig(false))
        ).subscribe(response => {
          this.toster.success('Worksheet concluded successfully');
        }, error => {
          this.toster.error(error.error);
        }).add(() => {
          this.getMasterTemplate();
          this.setRefreshProceduresWindow();
        });
      }
    }
  }

  reopenWorksheet() {
    const dialogRef = this.dialog.open(this.reopenWorksheetDialog, {
      disableClose: true
    });
    dialogRef.afterOpened().subscribe(opened => { });
    dialogRef.afterClosed().subscribe(closed => {
      if (closed) {
        if (this.ValidateJsonSections) {
          this.TemplateData.isConcluded = false;
          this.TemplateData.reopenedUser = {
            'userName':  this.userData.fullName,
            'timing': new Date().toUTCString()
          };
          const formData: FormData = this.worksheetService.getProceduresDataS3InsideEng(this.procedureFileName, this.TemplateData);
          this.updateSpinnerConfig(true);
          this.apiService.saveAndGetFileNamePath(formData).pipe(
            tap(response => {
              this.setAsWIP();
            }),
            finalize(() => this.updateSpinnerConfig(false))
          ).subscribe(response => {
          }, error => {
            this.toster.error(error.error);
          }).add(() => {
            this.getMasterTemplate();
            this.setRefreshProceduresWindow();
          });
        }
      } else {
      }
    });
  }

  handleDropToMiddleFiles(event: CdkDragDrop<DraggedFileModel, any>, sourceElement: SourceElementModel) {
    localStorage.setItem('dropToProcedure', 'true');
    const checkCopyExists = this.sharedService.allLeftSideTeamDocId;
    this.handleDropToMiddle(event, sourceElement);
  }

  updateReferance(message: string) {
    if (this.ValidateJsonSections) {
      const formData: FormData = this.worksheetService.getProceduresDataS3InsideEng(this.procedureFileName, this.TemplateData);
      this.updateSpinnerConfig(true);
      this.apiService.saveAndGetFileNamePath(formData).pipe(
        tap(response => {
          this.setAsWIP();
        }),
        finalize(() => this.updateSpinnerConfig(false))
      ).subscribe(response => {
        if (message) {
          this.toster.success(message);
          this.cancelAddReference();
          this.getMasterTemplate();
        }
      }, error => {
        this.toster.error(error.error);
      }).add(() => {
        // this.getMasterTemplate();
        this.setRefreshProceduresWindow();
      });
    }
  }

  checkObjectAvailability(oldRef, ref): boolean {
    if (oldRef != '') {
      return oldRef.some(obj => this.compareObjects(obj, ref));
    }

  }

  compareObjects(obj1: any, obj2: any): boolean {
    // Customize the comparison logic based on your object structure
    return obj1?.mssdkfileid ? (obj1.mssdkfileid === obj2.mssdkfileid) : !(obj1.engteamclientdocid === obj2.engteamclientdocid);
  }

  // On Ref Button Click
  addReferenceDocList() {
    const typeId = localStorage.getItem('indexForRefclick');
    if (this.selectedRightDocs.length || this.selectedLeftDocs.length) {
      let selectedFiles = [];
      if (this.selectedLeftDocs.length) {
        selectedFiles = this.selectedLeftDocs;
      } else if (this.selectedRightDocs.length) {
        selectedFiles = this.selectedRightDocs;
      }

      this.dropFileDetails = [];
      const index = this.masterTemplateData.tableData.findIndex(t => t.typeId == typeId);
      const ref = this.masterTemplateData.tableData[index].wpRef;
      if (ref instanceof Array) {
        selectedFiles.forEach(doc => {
          this.masterTemplateData.tableData[index].wpRef.push(doc);
        });
      } else {
        this.masterTemplateData.tableData[index].wpRef = selectedFiles;
      }
      this.TemplateData = JSON.parse(JSON.stringify(this.masterTemplateData));
      this.updateReferance('WP Ref added successfully');
    }
  }

  handleDropToMiddle(event: CdkDragDrop<DraggedFileModel, any>, sourceElement: SourceElementModel) {
    const procedure = JSON.parse(localStorage.getItem('procedureDetails'));
    sourceElement.finsubgroupid = procedure.finsubgroupid;
    sourceElement.submoduleid = procedure.submoduleid;
    sourceElement.finsubgroupname = procedure.finsubgroupname;
    sourceElement.leadsheetname = procedure.leadsheetName;
    sourceElement.leadsheetid = procedure.leadsheetId;
    const moduleSpecificParam = DragAndDropService.getModuleSpecificParam(sourceElement, ModuleInfo.MODULE_PROCEDURE,
      this.engagementData, this.userData);
    if (this.sharedService.dragFileOrigin === 'Left') {
      for (let i = 0; i < event.previousContainer.data.length; i++) {
        //if(this.sharedService.fileName == event.previousContainer.data[i].filename){
        let responseItem = new ResponseItemModel();
        responseItem.engTeamClientDocId = event.previousContainer.data[i].engteamclientdocid;
        responseItem.extension = event.previousContainer.data[i].extension;
        responseItem.extensionPath = event.previousContainer.data[i].extensionspath;
        responseItem.fileName = event.previousContainer.data[i].filename;
        responseItem.filePath = event.previousContainer.data[i].filepath;
        responseItem.mssdkfileid = event.previousContainer.data[i].mssdkfileid;
        const index = this.masterTemplateData?.tableData.findIndex(m => m.sortOrder === sourceElement.sortOrder)
        const ref = this.masterTemplateData.tableData[index].wpRef;
        console.log("object",index,sourceElement)
        if (this.checkObjectAvailability(ref, responseItem)) {
          this.toster.error(event.previousContainer.data[i].filename + ' Reference Alredy Exits');
        } else {
          if (event.previousContainer.data[i].filename != null) {
            this.addDraggedFileToRef(event.previousContainer.data[i], index);
          }

        }
        // }
      }
    } else {
      this.worksheetService.saveLeftDocProcedure.next(event);
      this.dragAndDropService.handleDropToMiddleES(event, sourceElement, moduleSpecificParam, this.sharedService.teamDocId);

      /*this.dragAndDropService.handleDropToTheMiddle(event, sourceElement, moduleSpecificParam, this.sharedService.teamDocId).then((response: ResponseModel) => {
       response.items.forEach((responseItem: ResponseItemModel) => {
       //this.dragAndDropService.showToasterForResponse(responseItem);
       if (responseItem.status === 200) {
       for (let i = 0; i < event.previousContainer.data.length; i++) {
       if (responseItem.originalFileName == event.previousContainer.data[i].filename) {
       responseItem.engTeamClientDocId = event.previousContainer.data[i].engteamclientdocid;
       responseItem.extension = event.previousContainer.data[i].extension;
       responseItem.extensionPath = event.previousContainer.data[i].extensionspath;
       responseItem.fileName = event.previousContainer.data[i].filename;
       responseItem.filePath = event.previousContainer.data[i].filepath;
       responseItem.mssdkfileid = event.previousContainer.data[i].mssdkfileid;
       localStorage.setItem('worksheetsDetails', JSON.stringify(responseItem));
       this.dragAndDropService.refreshCountable(event, sourceElement, responseItem, moduleSpecificParam);
       this.addDraggedFileToRef(event.previousContainer.data[i], indexForDragDrop);
       }
       }
       }
       });
       });*/
    }
  }

  addDraggedFileToRef(fileData, indexForDragDrop) {
    const normalizedName = fileData.filename;
    this.dropFileDetails = [];
    const ref = this.masterTemplateData.tableData[indexForDragDrop].wpRef;
    if (ref instanceof Array) {
      this.masterTemplateData.tableData[indexForDragDrop].wpRef.push(fileData);
    } else {
      this.dropFileDetails.push(fileData);
      this.masterTemplateData.tableData[indexForDragDrop].wpRef = this.dropFileDetails;
    }
    this.TemplateData = JSON.parse(JSON.stringify(this.masterTemplateData));
    this.updateReferance('WP Ref added successfully');
  }

  removeSelectedFile(ind, engteamclientdocid, row) {
    const index = this.masterTemplateData.tableData.findIndex(e => e.typeId === row.typeId);
    let ref = this.masterTemplateData.tableData[index].wpRef;
    ref = ref.filter(item => item.engteamclientdocid != engteamclientdocid);
    this.masterTemplateData.tableData[index].wpRef = JSON.parse(JSON.stringify(ref));
    this.TemplateData.tableData[index].wpRef = JSON.parse(JSON.stringify(ref));
    this.updateReferance('WP Ref removed successfully');
    if (row.wpRef && row.wpRef.length === 0) {
      this.referenceMenu.closeMenu();
    }
  }

  handleChangeOnRefClick(value, index, element) {
    this.isLeftSideSelectAll = false;
    this.isRightSideSelectAll = false;
    this.selectedSection = '1';
    this.isFilesExists = element.wpRef;
    this.getReferenceDocList('1');
    this.leftdocTypeId = element.typeId;
    this.rightdocindex = index;
    localStorage.setItem('indexForRefclick', this.leftdocTypeId);
    localStorage.setItem('tableData', value);
    this.isLeftSideSelectAll = false;
    this.isRightSideSelectAll = false;
    const dialogRef = this.dialog.open(this.WPRefTemplateDialog, {});
    dialogRef.afterClosed().subscribe(result => {
    });
    this.selectedLeftDocs = [];
    this.selectedRightDocs = [];
    this.referenceDocList = [];
    this.getReferencedDocListOpenFile();
  }

  getReferenceDocList(value) {
    if (value === '1') {
      this.referenceDocLeftSideList = [];
    } else {
      this.referenceDocRightSideList = [];
    }
    if (value === '1') {
      this.updateSpinnerConfig(true);
      this.engApiService.getProcedureLeftSectionDocs(this.engagementID).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: res => {
          const data = JSON.parse(res);
          const docsArray = data.docs ? [...data.docs] : [];
          const arrList = docsArray && docsArray.length > 0 ? docsArray.filter((doc: any) => doc && doc.engleftsidedocid && doc.engteamclientdocid) : [];
          const filterdList = arrList && arrList.length > 0 ? arrList : [];
          //to remove duplicate files from response (same obj with diffrent sectionpath from db)
          this.referenceDocLeftSideList = _.uniqBy(filterdList, 'engleftsidedocid');
          //  disable existing files from selection
          if (this.referenceDocLeftSideList && this.referenceDocLeftSideList.length && this.isFilesExists && this.isFilesExists.length) {
            this.isFilesExists.forEach(a => {
              this.referenceDocLeftSideList.forEach(b => {
                if (a.engteamclientdocid == b.engteamclientdocid) {
                  b.disabled = true;
                }
              });
            });
          }
        }, error: e => {
          this.toster.error(e.error);
        }
      });
    } else {
      this.updateSpinnerConfig(true);
      this.engApiService.getProRightSectionDocs(this.engagementID).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: res => {
          const response = JSON.parse(res);
          this.referenceDocRightSideList = response.docs ? [...response.docs] : [];
          //  disable existing files from selection
          if (this.referenceDocRightSideList && this.referenceDocRightSideList.length && this.isFilesExists && this.isFilesExists.length) {
            this.isFilesExists.forEach(a => {
              this.referenceDocRightSideList.forEach(b => {
                if (a.engteamclientdocid == b.engteamclientdocid) {
                  b.disabled = true;
                }
              });
            });
          }
        }, error: e => {
          this.toster.error(e.error);
        }
      });
    }
  }

  cancelAddReference() {
    this.selectedLeftDocs = [];
    this.selectedRightDocs = [];
    this.referenceDocList = [];
  }

  getReferencedDocListOpenFile() {
    const acountYear = this.engagementData.yearEnd;
    const acctYear = parseInt(this.countableTimeZonePipe.transform(acountYear, 'yyyy'));
    this.engApiService.getEngLeftSectionDocs(this.engagementData.engagementsid, acctYear).subscribe({
      next: res => {
        if (res.status === 200 && res.data) {
          this.docData = JSON.parse(res.data);
        }
      }, error: e => {
        this.toster.error(e.error);
      }
    });
  }

  onDocSelectionChange() {
    this.referenceDocList = this.selectedLeftDocs.concat(this.selectedRightDocs);
    if (this.selectedSection === '1') {
      if (this.selectedLeftDocs.length === this.referenceDocLeftSideList.filter(e => !e.disabled).length) {
        this.isLeftSideSelectAll = true;
      } else {
        this.isLeftSideSelectAll = false;
      }
    } else {
      if (this.selectedRightDocs.length === this.referenceDocRightSideList.filter(e => !e.disabled).length) {
        this.isRightSideSelectAll = true;
      } else {
        this.isRightSideSelectAll = false;
      }
    }
  }

  onSelectAllLeftSide(event) {
    if (event.currentTarget.checked) {
      this.selectedLeftDocs = this.referenceDocLeftSideList.filter(e => !e.disabled);
      this.isLeftSideSelectAll = true;
    } else {
      this.selectedLeftDocs = [];
      this.isLeftSideSelectAll = false;
    }
  }

  isSelectAllDisabled(data) {
    return data.every(e => e.disabled);
  }

  onSelectAllRightSide(event) {
    if (event.currentTarget.checked) {
      this.selectedRightDocs = this.referenceDocRightSideList.filter(e => !e.disabled);
      this.isRightSideSelectAll = true;
    } else {
      this.selectedRightDocs = [];
      this.isRightSideSelectAll = false;
    }
  }

  onClearAllLeftSide() {
    this.selectedLeftDocs = [];
    this.isLeftSideSelectAll = false;
    this.onDocSelectionChange();
  }

  onClearAllRightSide() {
    this.selectedRightDocs = [];
    this.isRightSideSelectAll = false;
    this.onDocSelectionChange();
  }

  onSeletionChange(event) {
    this.isLeftSideSelectAll = false;
    this.isRightSideSelectAll = false;
    this.selectedSection = event.value;
    if (this.selectedSection === '2') {
      localStorage.setItem('indexForRefclick', this.rightdocindex);
    } else if (this.selectedSection === '1') {
      localStorage.setItem('indexForRefclick', this.leftdocTypeId);
    }
    this.getReferenceDocList(this.selectedSection);
    this.selectedLeftDocs = [];
    this.selectedRightDocs = [];
  }

  onEditTemplate() {
    const nonEmptyRows = this.TemplateData.tableData.filter(row => !row.isEmptyRow);
    const emptyNature = nonEmptyRows.every(element => element.nature != '');
    const emptyType = nonEmptyRows.every(element => element.type != '');
    const emptyDesc = nonEmptyRows.every(element => element.description != '');
    this.isDescriptionEmpty = (emptyNature && emptyType && emptyDesc);
    this.enableCancelSave = true;
    this.sharedService.isEngScopeProcedureModified = true;
    this.worksheetProcData();
  }

  editDescription(element) {
    this.dataSource.data.forEach(val => {
      val['isDescEdited'] = false;
    });
    element.isDescEdited = true;
  }

  updateCommentDetails(element) {
    element.auther = this.userData.fullName;
    element.created = new Date().toUTCString();
    element['isCommentAvailable'] = element.comments.trim() ? true : false;
    const ind = this.TemplateData.tableData.findIndex(e => e.typeId === element.typeId);
    if (ind > -1) {
      this.TemplateData.tableData[ind].comments = element.comments;
      this.TemplateData.tableData[ind].auther = element.auther;
      this.TemplateData.tableData[ind].created = element.created;
      this.TemplateData.tableData[ind]['isCommentAvailable'] = element['isCommentAvailable'];
    }
    // this.TemplateData = JSON.parse(JSON.stringify(this.masterTemplateData));
    // console.log("Datasoruce", this.masterTemplateData);
  }

  getMaxNumber(idArr: number[]): number {
    return Math.max(...idArr) + 1;
  }

  enableSDK() {
    let doesFileExist = false;
    const rightSideFileNames = this.selectedRightDocs.map(doc => doc.filename);
    if (this.referenceDocLeftSideList && this.referenceDocLeftSideList.length) {
      this.referenceDocLeftSideList.forEach(file => {
        const fileName = file.filename.substring(file.REF.length + 1);
        if (rightSideFileNames.includes(fileName)) {
          doesFileExist = true;
        }
      });
    }
    if (doesFileExist) {
      this.toster.error('File name already exists in Left side');
      return;
    }
    let generateIdObjReturn: any;
    let generateIdObj = {'fileName': '', 'rightPath': '', 'leftPath': ''};
    let sdkDocObj = [];
    this.selectedRightDocs && this.selectedRightDocs.forEach(selectedItem => {
      var lastslashindex = selectedItem.filepath.lastIndexOf('/');
      this.sourceFilePath = selectedItem.filepath.slice(0, lastslashindex);
      //getting generateIdObjReturn object without copying file into s3
      generateIdObjReturn = this.createCopyOfFileInS3(selectedItem.filename, this.sourceFilePath, true);
      generateIdObj.fileName = generateIdObjReturn.fileName;
      generateIdObj.rightPath = generateIdObjReturn.sourceFolder + '/' + generateIdObj.fileName;
      generateIdObj.leftPath = generateIdObjReturn.destinationFolder + '/' + generateIdObj.fileName;
      this.updateSpinnerConfig(true);
      this.apiService.generateId(generateIdObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe(resp => {
        sdkDocObj.push(JSON.parse(resp));
        this.prepareSDKObject(sdkDocObj);
      }, error => {
        this.toster.error(error.error);
      });
    });
  }

  prepareSDKObject(sdkDocObj) {
    if (this.selectedRightDocs.length == sdkDocObj.length) {
      let sdkArray = [];
      sdkDocObj && sdkDocObj.forEach(sdkdoc => {
        sdkArray.push({
          'microsoftsdkfilesid': 0,
          'lockvalue': 'null',
          'lockexpires': 'null',
          'size': sdkdoc.fileSizeInNumber[0],
          'version': '1',
          'userinfo': this.userData.emailAddress,
          'isdelete': 0,
          'sizeinbytes': sdkdoc.fileSizeInBytes[0],
          'mssdkfileid': sdkdoc.fileIds[0],
          'filename': sdkdoc.fileNames[0],
          'filepath': sdkdoc.filePaths[0],
          'extension': sdkdoc.fileNames[0].split('.').pop()
        });
      });

      this.addRightReferenceDocList(sdkArray);
    }
  }

  // making copy of moved item into s3 folder
  createCopyOfFileInS3(fileName, sourceFolder, sdkConfirmation) {
    let s3signatureKey = 'Engagements/' + this.userData.firmUserAcctId + '_Firm/' + this.engagementData.clientfirmid + '_Client/'
      + this.engagementData.engagementsid + '_Engagements/' + 'EngagementDocs/Worksheet';

    const copyFileObj = {
      'status': 0,
      'sourceFolder': sourceFolder,
      'destinationFolder': s3signatureKey,
      'fileName': fileName,
      'firmId': this.userData.firmUserAcctId,
      'clientId': this.engagementData.clientfirmid,
      'engagementId': this.engagementData.engagementsid,
      'folderName': 'Worksheet',
      'appSyncId': this.userData.useracctid,
      'module': 9
    };

    if (!sdkConfirmation) { // copying file into S3 bucket
      this.apiService.copyFileInS3(this.encodingService.enData(copyFileObj, 'body')).subscribe(resp => { });
    } else {
      return copyFileObj; // //return filepath without copying file
    }
  }

  addRightReferenceDocList(sdkArray?) {
    const procedure = JSON.parse(localStorage.getItem('procedureDetails'));
    let refObj = [];
    this.referenceDocList && this.referenceDocList.forEach(element => {
      refObj.push({
        'submoduleid': procedure.submoduleid,
        'engagementsid': this.engagementID,
        'loginid': this.userData.useracctid,
        'filename': element.filename,
        'filepath': element.filepath,
        'engteamclientdocid': element.engteamclientdocid,
        'engleftsidedocid': element.engleftsidedocid,
        'extension': element.filename.split('.').pop(),
        'isdelete': 0
      });
    });

    sdkArray = this.selectedSection == '2' ? sdkArray : null;
    let finalRefObject = {
      'docleft': refObj,
      'sdk': sdkArray
    };
    let finalObj = JSON.stringify(finalRefObject);
    this.updateSpinnerConfig(true);
    this.engApiService.saveEngDocMiddleRef(finalObj).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          const docInfo = JSON.parse(res?.data);
          this.sharedService.isDocReference.next(docInfo);
          this.sharedService.docReferencedSuccessfully.next('success');

          const indexForDragDrop = localStorage.getItem('indexForRefclick');
          if (this.selectedRightDocs.length || this.selectedLeftDocs.length) {
            this.dropFileDetails = [];
            const ref = this.TemplateData.tableData[indexForDragDrop].wpRef;
            if (ref instanceof Array && docInfo && docInfo.length) {
              docInfo.forEach(doc => {
                this.TemplateData.tableData[indexForDragDrop].wpRef.push(doc);
              });
            } else {
              this.TemplateData.tableData[indexForDragDrop].wpRef = docInfo;
            }
            this.updateReferance('WP Ref added successfully');
          }
          this.cancelAddReference();
        }
      }, error: e => {
        this.toster.error(e.error);
      }
    }).add(() => {
      this.getMasterTemplate();
    });
  }

  deleteReference(ref) {
    this.referenceDocList = this.referenceDocList.filter(element => element.engteamclientdocid !== ref.engteamclientdocid);
    this.selectedRightDocs = this.selectedRightDocs.filter(element => element.engteamclientdocid !== ref.engteamclientdocid);
    this.selectedLeftDocs = this.selectedLeftDocs.filter(element => element.engteamclientdocid !== ref.engteamclientdocid);

    if (this.selectedRightDocs.length === this.referenceDocLeftSideList.length && this.selectedSection === '2' || this.selectedLeftDocs.length === this.referenceDocRightSideList.length && this.selectedSection === '1') {
      this.isRightSideSelectAll = this.selectedSection === '2' ? true : this.isRightSideSelectAll;
      this.isLeftSideSelectAll = this.selectedSection === '1' ? true : this.isLeftSideSelectAll;
    } else {
      this.isRightSideSelectAll = this.selectedSection === '2' ? false : this.isRightSideSelectAll;
      this.isLeftSideSelectAll = this.selectedSection === '1' ? false : this.isLeftSideSelectAll;
    }
  }

  worksheetProcData() {
    this.isAddRowBtnEnabled.set(false);
    if (this.dataSource.data && this.dataSource.data.length) {
      this.dataSource.data.forEach(e => {
        if (!e.nature.trim().length || !e.type.trim().length || !e.description.trim().length) {
          this.isAddRowBtnEnabled.set(true);
        }
      });
    }
  }

  checkPrefix(data: string) {
    if (data.lastIndexOf('-') === (data.length - 1)) {
      return data.substring(0, data.length - 1);
    } else {
      return data;
    }
  }

  private setAsWIP() {
    const isSheetWIP = (this.dataSource.data && this.dataSource.data.length > 0) && this.dataSource.data.some((row: any) => row.comments !== '' || (row.wpRef && row.wpRef.length > 0));
    if (isSheetWIP && (this.leadSheetData && this.leadSheetData.is_mappinng_enabled === 0)) {
      return;
    }
    const inputObj: WorksheetProceduresDBModel = new WorksheetProceduresDBModel();
    inputObj.is_mappinng_enabled = isSheetWIP ? 0 : 1;
    inputObj.JsonFilePath = this.leadSheetData.JsonFilePath ?? this.procedureFilePath;
    inputObj.JsonFileName = this.leadSheetData.JsonFileName ?? this.procedureFileName;
    inputObj.engagementsid = this.engagementID;
    inputObj.leadsheetid = this.leadSheetData.leadsheetid;
    inputObj.loginid = this.userData.useracctid;
    inputObj.additional_procedure = this.leadSheetData.additional_procedure;
    const data = JSON.stringify({'data': [inputObj]});
    this.updateSpinnerConfig(true);
    this.subcriptions.add(
      this.engApiService.saveEngPlanningTemplate(data).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
        next: res => {
          this.sharedService.refreshLeftFolder$.next('Procedures');
          this.leadSheetData.is_mappinng_enabled = 0;
        },
        error: err => {
        }
      })
    );
  }

  private setRefreshProceduresWindow() {
    const engId = +localStorage.getItem('engagementID');
    const REFRESH_KEY = 'isRefreshProceduresWindow-' + engId + '-' + this.leadSheetData.leadsheetid;
    localStorage.setItem(REFRESH_KEY, 'true');
  }

  private updateSpinnerConfig(value: boolean) {
      value ? this.spinCount++ : (this.spinCount = Math.max(0, this.spinCount - 1));
      const spinner = this.spinnerConfig();
      this.spinnerConfig.set({
       ...spinner,
         isSpinShown: this.spinCount > 0
       });
     }

}


